// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"bb43c3b2","557":"e1e357ed"}[chunkId] + ".chunk.css";
};